import template from './environment_config.create.html';
import controller from './environment_config.create.controller';
import './environment_config.create.scss';

const environmentConfigCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default environmentConfigCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/create/environment_config.create.component.js